import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const milestones = [
  { year: '2024', title: '平台上线', description: '香香漫画正式上线，首批收录超过500部优质韩漫，致力于为中文读者提供免费优质的韩漫阅读体验。' },
  { year: '2024', title: '用户突破10万', description: '凭借海量免费内容和流畅的下拉式阅读体验，注册用户迅速突破10万，日活跃读者超过3万人。' },
  { year: '2025', title: '内容扩展', description: '漫画库扩展至2000+部作品，涵盖恋爱、奇幻、动作、悬疑等10大分类，成为韩漫领域最具影响力的中文阅读平台之一。' },
  { year: '2025', title: '用户突破100万', description: '月活跃用户突破100万，平均每位读者每日阅读时长超过45分钟，平台口碑持续攀升。' },
  { year: '2026', title: '体验升级', description: '推出全新阅读器，优化下拉式阅读体验，加载速度提升300%，为读者带来更流畅的阅读享受。' },
];

const reviews = [
  { name: '小美', rating: 5, comment: '用了香香漫画快一年了，资源超全，追更速度也很快。下拉式阅读体验真的很棒，不用翻页直接往下滑就行！', date: '2026-07-28' },
  { name: '漫画迷阿杰', rating: 5, comment: '找了很久的韩漫在这里都能找到，画质清晰，加载速度快。最喜欢分类做得很好，推荐系统也很准。', date: '2026-07-25' },
  { name: '星星眼', rating: 5, comment: '免费而且内容超多，真的良心平台。每天必刷，已经推荐给身边所有喜欢漫画的朋友了！', date: '2026-07-20' },
  { name: '追漫达人', rating: 4, comment: '韩漫资源确实很全，更新也比较及时。希望后续能上线更多完结作品。整体使用体验很好。', date: '2026-07-15' },
  { name: '小雨点', rating: 5, comment: '从其他平台转过来的，没想到免费的居然做得这么好。界面干净无广告干扰，阅读体验一级棒！', date: '2026-07-10' },
  { name: '漫画控', rating: 5, comment: '内容质量很高，漫画画质清晰。下拉式阅读太适合手机看了，通勤路上必备神器。', date: '2026-07-05' },
];

const faqs = [
  { q: '香香漫画是免费的吗？', a: '是的，香香漫画所有漫画内容均可免费阅读，无需付费订阅。我们致力于为漫画爱好者提供免费的优质阅读体验。' },
  { q: '什么下拉式阅读？', a: '下拉式阅读是一种现代化的漫画阅读方式，您只需向下滑动页面即可连续阅读，无需手动翻页。相比传统翻页模式，下拉式阅读更加流畅自然，尤其适合移动端阅读。' },
  { q: '漫画更新频率如何？', a: '我们与多家韩漫内容方保持紧密合作，尽可能在第一时间同步更新最新章节。热门连载作品通常能够在官方发布后24小时内更新。' },
  { q: '支持哪些设备阅读？', a: '香香漫画支持在电脑、平板和手机上阅读。无论您使用什么设备，都能享受流畅的下拉式阅读体验。' },
  { q: '如何搜索我想看的漫画？', a: '您可以通过首页顶部的搜索功能输入漫画名称或作者来查找，也可以通过分类页面按类型浏览感兴趣的漫画。' },
];

export default function AboutPage() {
  useEffect(() => {
    document.title = '关于我们 - 香香漫画韩漫免费阅读平台';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '香香漫画',
    url: 'https://xiangxiangmanhua.com',
    description: '海量韩漫免费阅读平台，韩漫全集下拉式畅读',
    email: 'contact@xiangxiangmanhua.com',
    foundingDate: '2024',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(f => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://xiangxiangmanhua.com/' },
      { '@type': 'ListItem', position: 2, name: '关于我们' },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <nav className="px-4 md:px-6 py-4" aria-label="面包屑导航">
            <ol className="flex items-center gap-2 text-sm text-foreground-500">
              <li><Link to="/" className="hover:text-primary-500 transition-colors">首页</Link></li>
              <li><i className="ri-arrow-right-s-line text-xs"></i></li>
              <li className="text-foreground-800">关于我们</li>
            </ol>
          </nav>

          <section className="px-4 md:px-6 py-10 md:py-16">
            <div className="mx-auto max-w-4xl text-center">
              <h1 className="text-3xl md:text-5xl font-heading text-foreground-950 mb-4">关于香香漫画</h1>
              <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
                香香漫画成立于2024年，是一个专注于韩漫免费阅读的中文平台。我们致力于为广大漫画爱好者提供海量、优质、免费的韩漫内容，以流畅的下拉式阅读体验，让每一位读者都能畅享漫画的乐趣。
              </p>
            </div>
          </section>

          <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100" aria-labelledby="milestones-title">
            <div className="mx-auto max-w-4xl">
              <h2 id="milestones-title" className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
                品牌历程
              </h2>
              <div className="space-y-0">
                {milestones.map((m, idx) => (
                  <div key={idx} className="flex gap-4 md:gap-6">
                    <div className="flex flex-col items-center">
                      <div className="w-3 h-3 rounded-full bg-primary-500 flex-shrink-0 mt-1.5"></div>
                      {idx < milestones.length - 1 && (
                        <div className="w-px flex-1 bg-background-300 mt-1"></div>
                      )}
                    </div>
                    <div className="pb-8">
                      <span className="inline-block px-2.5 py-0.5 rounded-md bg-primary-500/10 text-primary-500 text-xs font-medium mb-2">
                        {m.year}
                      </span>
                      <h3 className="text-lg text-foreground-800 font-semibold mb-1">{m.title}</h3>
                      <p className="text-sm text-foreground-600 leading-relaxed">{m.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="px-4 md:px-6 py-10 md:py-14" aria-labelledby="reviews-title">
            <div className="mx-auto max-w-4xl">
              <h2 id="reviews-title" className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
                用户口碑
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {reviews.map((review, idx) => (
                  <div key={idx} className="bg-background-100 rounded-lg p-5">
                    <div className="flex items-center gap-1.5 mb-3">
                      {Array.from({ length: 5 }, (_, i) => (
                        <i
                          key={i}
                          className={`text-sm ${
                            i < review.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-400'
                          }`}
                        ></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-3">{review.comment}</p>
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-foreground-800 font-medium">{review.name}</span>
                      <span className="text-xs text-foreground-500">{review.date}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100" aria-labelledby="contact-title">
            <div className="mx-auto max-w-4xl">
              <h2 id="contact-title" className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
                联系我们
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div className="bg-background-50 rounded-lg p-6 text-center">
                  <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-primary-500/10 flex items-center justify-center">
                    <i className="ri-mail-line text-xl text-primary-500"></i>
                  </div>
                  <h3 className="text-foreground-800 font-semibold text-sm mb-1">电子邮件</h3>
                  <p className="text-sm text-foreground-500">contact@xiangxiangmanhua.com</p>
                </div>
                <div className="bg-background-50 rounded-lg p-6 text-center">
                  <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-primary-500/10 flex items-center justify-center">
                    <i className="ri-wechat-line text-xl text-primary-500"></i>
                  </div>
                  <h3 className="text-foreground-800 font-semibold text-sm mb-1">微信公众号</h3>
                  <p className="text-sm text-foreground-500">香香漫画</p>
                </div>
                <div className="bg-background-50 rounded-lg p-6 text-center">
                  <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-primary-500/10 flex items-center justify-center">
                    <i className="ri-customer-service-line text-xl text-primary-500"></i>
                  </div>
                  <h3 className="text-foreground-800 font-semibold text-sm mb-1">客服支持</h3>
                  <p className="text-sm text-foreground-500">工作日 9:00 - 18:00</p>
                </div>
              </div>
            </div>
          </section>

          <section className="px-4 md:px-6 py-10 md:py-14" aria-labelledby="faq-title">
            <div className="mx-auto max-w-3xl">
              <h2 id="faq-title" className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
                常见问题
              </h2>
              <div className="space-y-3">
                {faqs.map((faq, idx) => (
                  <details key={idx} className="bg-background-100 rounded-lg group">
                    <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                      <span className="text-sm font-medium text-foreground-800 pr-4">{faq.q}</span>
                      <i className="ri-add-line text-foreground-500 group-open:hidden flex-shrink-0"></i>
                      <i className="ri-subtract-line text-foreground-500 hidden group-open:block flex-shrink-0"></i>
                    </summary>
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}